import { render, staticRenderFns } from "./PropertyList.vue?vue&type=template&id=525167a2&scoped=true"
import script from "./PropertyList.vue?vue&type=script&lang=ts"
export * from "./PropertyList.vue?vue&type=script&lang=ts"
import style0 from "./PropertyList.vue?vue&type=style&index=0&id=525167a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525167a2",
  null
  
)

export default component.exports